(() => {
  if (window.__cardVariantSaleSyncStarted === true) {
    return;
  }

  window.__cardVariantSaleSyncStarted = true;

  const CARD_VARIANT_SELECTORS = [
    '[data-bentosmb-card-variant-id]',
    '[data-eosh-variant-id]',
    '[swatch-default-variant]'
  ].join(', ');

  const CARD_DATA_SELECTOR =
    '[data-card-product-swatches]';

  const VARIANTS_SCRIPT_SELECTOR =
    '[data-card-product-swatches-variants]';

  const SALE_BADGE_SELECTOR =
  '[data-card-sale-badge]';

  const normalizeId = (value) => {
    return String(value || '').trim();
  };

  const parseJsonScript = (
    root,
    selector,
    fallback = []
  ) => {
    if (!root) return fallback;

    const script = root.querySelector(selector);

    if (!script) return fallback;

    try {
      return JSON.parse(
        script.textContent || '[]'
      );
    } catch (error) {
      console.error(
        'Card variant sale data failed to parse:',
        error
      );

      return fallback;
    }
  };

  const getCardWrapper = (element) => {
    if (!element) return null;

    return element.closest('.card-wrapper');
  };

  const getCardVariantDataElement = (
    cardWrapper
  ) => {
    if (!cardWrapper) return null;

    return cardWrapper.querySelector(
      CARD_DATA_SELECTOR
    );
  };

  const getAssignedCardVariantId = (
    element
  ) => {
    if (!element) return '';

    const cardItem = element.closest(
      CARD_VARIANT_SELECTORS
    );

    const variantId = normalizeId(
      cardItem?.getAttribute(
        'data-bentosmb-card-variant-id'
      ) ||
        cardItem?.getAttribute(
          'data-eosh-variant-id'
        ) ||
        cardItem?.getAttribute(
          'swatch-default-variant'
        )
    );

    if (cardItem && variantId) {
      cardItem.setAttribute(
        'data-bentosmb-card-variant-id',
        variantId
      );
    }

    return variantId;
  };

  const getAssignedVariant = (
    cardWrapper
  ) => {
    if (!cardWrapper) return null;

    const variantId =
      getAssignedCardVariantId(cardWrapper);

    if (!variantId) return null;

    const dataElement =
      getCardVariantDataElement(cardWrapper);

    if (!dataElement) return null;

    const variants = parseJsonScript(
      dataElement,
      VARIANTS_SCRIPT_SELECTOR
    );

    if (!Array.isArray(variants)) {
      return null;
    }

    return (
      variants.find((variant) => {
        return (
          normalizeId(variant.id) ===
          variantId
        );
      }) || null
    );
  };

  const getVariantPrice = (variant) => {
    if (!variant) return '';

    return (
      variant.priceFormatted ||
      variant.formattedPrice ||
      variant.moneyPrice ||
      ''
    );
  };

  const getVariantCompareAtPrice = (
    variant
  ) => {
    if (!variant) return '';

    return (
      variant.compareAtPriceFormatted ||
      variant.formattedCompareAtPrice ||
      variant.moneyCompareAtPrice ||
      ''
    );
  };

  const isVariantOnSale = (variant) => {
    if (!variant) return false;

    if (
      typeof variant.onSale === 'boolean'
    ) {
      return variant.onSale;
    }

    const price = Number(variant.price);
    const compareAtPrice = Number(
      variant.compareAtPrice
    );

    return (
      Number.isFinite(price) &&
      Number.isFinite(compareAtPrice) &&
      compareAtPrice > price
    );
  };

const syncSaleBadges = (
  cardWrapper,
  variant
) => {
  if (!cardWrapper) return;

  const onSale =
    Boolean(variant) &&
    isVariantOnSale(variant);

  cardWrapper
    .querySelectorAll(
      SALE_BADGE_SELECTOR
    )
    .forEach((badge) => {
      badge.hidden = !onSale;

      badge.setAttribute(
        'aria-hidden',
        onSale ? 'false' : 'true'
      );

      badge.style.display =
        onSale ? '' : 'none';
    });
};

  const syncPriceElement = (
    priceElement,
    variant
  ) => {
    if (!priceElement || !variant) {
      return;
    }

    const onSale =
      isVariantOnSale(variant);

    const priceFormatted =
      getVariantPrice(variant);

    const compareAtPriceFormatted =
      getVariantCompareAtPrice(variant);

    const regularPrice =
      priceElement.querySelector(
        '.price__regular .price-item--regular'
      );

    const saleCompareAtPrice =
      priceElement.querySelector(
        '.price__sale s.price-item--regular'
      );

    const salePrice =
      priceElement.querySelector(
        '.price__sale .price-item--sale'
      );

    if (priceFormatted && regularPrice) {
      regularPrice.textContent =
        priceFormatted;
    }

    if (onSale) {
      priceElement.classList.add(
        'price--on-sale'
      );

      if (
        saleCompareAtPrice &&
        compareAtPriceFormatted
      ) {
        saleCompareAtPrice.textContent =
          compareAtPriceFormatted;
      }

      if (
        salePrice &&
        priceFormatted
      ) {
        salePrice.textContent =
          priceFormatted;
      }

      return;
    }

    priceElement.classList.remove(
      'price--on-sale'
    );

    if (
      regularPrice &&
      priceFormatted
    ) {
      regularPrice.textContent =
        priceFormatted;
    }

    /*
     * Keep the hidden sale markup internally
     * consistent in case another script or theme
     * temporarily exposes it.
     */
    if (
      salePrice &&
      priceFormatted
    ) {
      salePrice.textContent =
        priceFormatted;
    }
  };

  const syncCardPrice = (
    cardWrapper,
    variant
  ) => {
    if (!cardWrapper || !variant) return;

    cardWrapper
      .querySelectorAll(
        '.card-information .price'
      )
      .forEach((priceElement) => {
        syncPriceElement(
          priceElement,
          variant
        );
      });
  };

  const syncCard = (cardWrapper) => {
  if (!cardWrapper) return false;

  const variantId =
    getAssignedCardVariantId(cardWrapper);

  // Normal collection card.
  // Let Liquid control the sale badge.
  if (!variantId) {
    return false;
  }

  const dataElement =
    getCardVariantDataElement(cardWrapper);

  const variants = dataElement
    ? parseJsonScript(
        dataElement,
        VARIANTS_SCRIPT_SELECTOR
      )
    : [];

  const variant =
    Array.isArray(variants)
      ? variants.find(
          (item) =>
            normalizeId(item.id) ===
            variantId
        ) || null
      : null;

  syncSaleBadges(
    cardWrapper,
    variant
  );

  if (!variant) {
    return false;
  }

  syncCardPrice(
    cardWrapper,
    variant
  );

  cardWrapper.setAttribute(
    'data-card-variant-sale-synced',
    normalizeId(variant.id)
  );

  return true;
};

  const syncCardsInRoot = (
    root = document
  ) => {
    const wrappers = new Set();

    if (
      root instanceof Element &&
      root.matches('.card-wrapper')
    ) {
      wrappers.add(root);
    }

    if (
      root instanceof Element
    ) {
      const closestWrapper =
        root.closest('.card-wrapper');

      if (closestWrapper) {
        wrappers.add(
          closestWrapper
        );
      }
    }

    if (
      root === document ||
      root instanceof Element
    ) {
      root
        .querySelectorAll?.(
          '.card-wrapper'
        )
        .forEach((cardWrapper) => {
          wrappers.add(cardWrapper);
        });
    }

    wrappers.forEach(
      (cardWrapper) => {
        syncCard(cardWrapper);
      }
    );
  };

  let refreshQueued = false;
  let refreshTimer = null;

  const scheduleRefresh = () => {
    if (refreshQueued) return;

    refreshQueued = true;

    requestAnimationFrame(() => {
      refreshQueued = false;

      window.clearTimeout(
        refreshTimer
      );

      /*
       * First pass handles normal rendering.
       */
      syncCardsInRoot();

      /*
       * EoSH may modify the same cards shortly
       * after inserting them, so do one delayed
       * settling pass as well.
       */
      refreshTimer =
        window.setTimeout(() => {
          syncCardsInRoot();
        }, 100);
    });
  };

  const observeVariantCards = () => {
    const root =
      document.querySelector(
        '#product-grid'
      ) ||
      document.querySelector(
        '[data-id*="product-grid"]'
      ) ||
      document.querySelector(
        '.product-grid'
      ) ||
      document.body;

    if (!root) return;

    const observer =
      new MutationObserver(
        (mutations) => {
          let shouldRefresh = false;

          for (
            const mutation of mutations
          ) {
            if (
              mutation.type ===
              'attributes'
            ) {
              if (
                mutation.attributeName ===
                  'data-eosh-variant-id' ||
                mutation.attributeName ===
                  'swatch-default-variant'
              ) {
                shouldRefresh = true;
                break;
              }

              continue;
            }

            if (
              mutation.type !==
              'childList'
            ) {
              continue;
            }

            for (
              const node of
              mutation.addedNodes
            ) {
              if (
                !(node instanceof Element)
              ) {
                continue;
              }

              if (
                node.matches(
                  CARD_VARIANT_SELECTORS
                ) ||
                node.matches(
                  '.card-wrapper'
                ) ||
                node.querySelector(
                  CARD_VARIANT_SELECTORS
                ) ||
                node.querySelector(
                  CARD_DATA_SELECTOR
                )
              ) {
                shouldRefresh = true;
                break;
              }
            }

            if (shouldRefresh) {
              break;
            }
          }

          if (shouldRefresh) {
            scheduleRefresh();
          }
        }
      );

    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'data-eosh-variant-id',
        'swatch-default-variant'
      ]
    });
  };

  const prepareCardBeforeNavigation = (
    event
  ) => {
    if (
      !(event.target instanceof Element)
    ) {
      return;
    }

    const cardWrapper =
      event.target.closest(
        '.card-wrapper'
      );

    if (!cardWrapper) return;

    syncCard(cardWrapper);
  };

  document.addEventListener(
    'pointerdown',
    prepareCardBeforeNavigation,
    true
  );

  document.addEventListener(
    'click',
    prepareCardBeforeNavigation,
    true
  );

  window.addEventListener(
    'pageshow',
    () => {
      scheduleRefresh();
    }
  );

  const start = () => {
    syncCardsInRoot();

    observeVariantCards();

    /*
     * A few additional settling passes cover
     * third-party scripts that initialize after
     * DOMContentLoaded.
     */
    requestAnimationFrame(() => {
      syncCardsInRoot();

      requestAnimationFrame(() => {
        syncCardsInRoot();
      });
    });

    window.setTimeout(() => {
      syncCardsInRoot();
    }, 150);

    window.setTimeout(() => {
      syncCardsInRoot();
    }, 500);
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }
})();